import { Attachment } from "../../../domain/model/Attachment";
import { Transaction } from "../../../domain/model/Transaction";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { TransactionRepository } from "./TransactionRepository";

export class TransactionRepositoryImpl implements TransactionRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  getAll(skip?: number, limit?: number): Promise<Response<Array<Transaction>>> {
    return this.apiService.getTransactions(skip, limit);
  }
}
